<kno2-dialog-body>
    <div class="container-fluid p-0">
        @if (error()) {
            <kno2-notification-alert
                type="danger"
                [title]="error()"
                (dismiss)="error.set(null)"></kno2-notification-alert>
        }

        <p class="mb-4">
            There was a challenge in verifying your identity. This could be due to a variety of reasons and is no need to be concerned. Our next step is to
            perform a manual identification process. To do this, please scan a copy of your driver's license or another form of government ID with your photo.
            Attach the scanned file of the ID using the Browse button and selecting the Submit button. Your ID will be securely sent to the Client department
            for review and approval. You will receive an email confirming the status of the manual identity verification process shortly.
        </p>

        <p class="mb-4">
            If you do not have a government issued ID readily available, no problem. You can pick up from this spot at any time. Simply log out and log back in
            and you will be brought to this same screen.
        </p>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-end fw-bold">Select a file to upload</label>
            <div class="col-sm-6">
                <div class="col-sm-12 form-control">
                    <span>{{ selectedFile() ? (selectedFile()!.name | truncateText: 60) : "No file selected" }}</span>
                </div>
                @if (fileRequired()) {
                    <div class="text-danger small mt-1">Please select a file to upload</div>
                }
            </div>
            <div class="col-sm-2">
                <span class="btn btn-inverse w-100 fileinput-button">
                    Browse
                    <input
                        (change)="onFileSelected($event)"
                        type="file"
                        name="file"
                        accept="image/*,.pdf"
                        [disabled]="isUploading()" />
                </span>
            </div>
        </div>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        type="button"
        class="btn btn-inverse"
        [disabled]="isUploading()"
        (click)="closeModal()">
        Close
    </button>
    <button
        type="submit"
        class="btn btn-primary px-4"
        [disabled]="!isFormValid() || isUploading()"
        (click)="uploadId()">
        @if (isUploading()) {
            <span class="spinner-border spinner-border-sm me-2"></span>
        }
        Submit
    </button>
</kno2-dialog-footer>
